<template>
    <div v-loading="fullscreenLoading" element-loading-background="rgba(255, 255, 255, 0.4)">
        <el-form :label-position="left" :inline="true" size="mini" label-width="80px" :model="formInline" class="demo-form-inline">
            <el-row>
                <el-form-item label="桌位号">
                    <el-input v-model="formInline.tcNo"></el-input>
                </el-form-item>
                <el-form-item label="名称">
                    <el-input v-model="formInline.name"></el-input>
                </el-form-item>
                <el-form-item label="桌牌码">
                    <el-input v-model="formInline.tcForeignId"></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="日期">
                    <el-date-picker v-model="value7" type="daterange" align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
                <el-button size="mini" type="primary" @click="open3" icon="el-icon-circle-plus-outline">添加桌位</el-button>
                <el-button size="mini" type="primary" icon="el-icon-download" @click="donwAll">批量下载</el-button>
            </el-row>
        </el-form>
        <el-table size="mini" ref="multipleTable" :data="tableData3" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center">
            </el-table-column>
            <el-table-column label="序号" type="index" :index="indexMethod" align="center">
            </el-table-column>
            <el-table-column label="名称" prop="name" align="center">
            </el-table-column>
            <el-table-column label="桌位号" prop="tcNo" width="100" align="center">
            </el-table-column>
            <el-table-column label="可容纳人数" prop="capacity" align="center">
            </el-table-column>
            <el-table-column label="桌牌码" prop="tcForeignId" align="center">
            </el-table-column>
            <el-table-column prop="rowCrtTsStr" label="创建日期" align="center">
              
            </el-table-column>
            <el-table-column prop="address" label="操作" show-overflow-tooltip width="330px" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="cal(scope.row)">清空桌位</el-button>
                    <el-button size="mini" type="primary" icon="el-icon-edit" @click="edit(scope.row)">修改</el-button>
                    <el-button size="mini" type="primary" icon="el-icon-download" @click="donw(scope.row.tcForeignId)">下载二维码</el-button>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div class="block">
            <el-pagination class="right" @current-change="handleCurrentChange" :current-page="page.currentPage" :page-size="10" layout="total, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
        </div>
        <el-dialog title="添加桌位" :visible.sync="dialogFormVisible" width="400px">
            <el-form :rules="rules" ref="ruleForm2" label-position="left" :model="form" size="mini" label-width="110px">
                <el-form-item label="名称：" prop="name">
                    <el-input v-model="form.name" maxlength="10"></el-input>
                </el-form-item>
                <!-- <el-form-item label="桌位码编号：" prop="tcForeignId">
                    <el-input v-model="form.tcForeignId"></el-input>
                </el-form-item> -->
                <el-form-item label="可容纳人数：" prop="capacity">
                    <el-input v-model="form.capacity"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" :loading="dialogFormVisible_" @click="addList()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改" :visible.sync="dialogFormVisible1" width="400px">
            <el-form :rules="rules_" ref="ruleForm2_" label-position="left" :model="form_" size="mini" label-width="110px">
                <el-form-item label="名称：" prop="name">
                    <el-input v-model="form_.name" maxlength="10"></el-input>
                </el-form-item>
                <!-- <el-form-item label="桌牌码:" prop="tcForeignId">
                    <el-input v-model="form_.tcForeignId"></el-input>
                </el-form-item> -->
                <el-form-item label="可容纳人数：" prop="capacity">
                    <el-input v-model="form_.capacity"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogFormVisible1 = false">取 消</el-button>
                <el-button size="mini" type="primary" :loading="dialogFormVisible1_" @click="editList()">确 定</el-button>
            </div>
        </el-dialog>
        <export-file ref="exportFile" :URL="URL"></export-file>
    </div>
</template>

<script>
import Eve from "../../../components/common/emit.js";
import { baseurl } from "../../../base.js";
export default {
  created() {
    Eve.$on("tableCardList", () => {
      this.load();
    });
    this.load();
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("必填项"));
      } else {
        let str = /^[1-9]\d*$/;
        if (!str.test(value)) {
          callback(new Error("请输入大于0的整数"));
        } else {
          callback();
        }
      }
    };
    var kongge = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("必填项"));
      } else {
        let str = /^\S+$/;
        if (!str.test(value)) {
          callback(new Error("请输入正确的桌位名称"));
        } else {
          callback();
        }
      }
    };
    var validatePass_ = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else {
        let str = /^[1-9]\d*$/;
        if (!str.test(value)) {
          callback(new Error("请输入大于0的整数"));
        } else {
          callback();
        }
      }
    };
    return {
      URL: `${baseurl}/w/tableCard/qrCodeBatchDownload`,
      form: {
        name: "",
        tcForeignId: "",
        capacity: "4"
      },
      form_: {
        name: "",
        tcForeignId: "",
        tcNo: "",
        capacity: "",
        id: ""
      },
      rules_: {
        name: [
          { required: true, message: "请输入正确的桌位名称", trigger: "blur" },
          { validator: kongge, trigger: "blur"},
          {
            min: 1,
            max: 10,
            message: "请输入1到10个字符",
            trigger: "change"
          }
        ],
        tcForeignId: [{ required: true, message: "必填", trigger: "change" },{ validator: validatePass, trigger: "blur" }],
        capacity: [ {
            min: 0,
            max: 3,
            message: "最大为3位正整数",
            trigger: "change"
          },{ validator: validatePass_, trigger: "change" },]
      },
      rules: {
        name: [
          { required: true, message: "请输入正确的桌位名称", trigger: "change" },
          { validator: kongge, trigger: "blur"},
          {
            min: 1,
            max: 10,
            message: "请输入1到10个字符",
            trigger: "change"
          }
        ],
        tcForeignId: [{ required: true, message: "必填", trigger: "change" }],
        capacity: [{ validator: validatePass_, trigger: "blur"},{
          min: 0,
            max: 3,
            message: "最大为3位正整数",
            trigger: "change"
          }]
      },
      dialogFormVisible1: false,
      dialogFormVisible1_: false,
      dialogFormVisible: false,
      dialogFormVisible_: false,
      baseurl: baseurl,
      fullscreenLoading: false,
      page: {
        total: 0,
        currentPage: 1
      },
      value7: "",
      left: "left",
      tableData3: [],
      multipleSelection: [],
      formInline: {
        name: "",
        tcNo: "",
        startTime: "",
        tcForeignId: "",
        endTime: "",
        page: 1,
        size: 10
      }
    };
  },
  methods: {
    indexMethod(index) {
      return (this.page.currentPage - 1) * 10 + index + 1;
    },
    cal(obj) {
      this.$confirm("此操作将清空桌位订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http.post(`/w/tableCard/clear/${obj.tcNo}`).then(data => {
            this.$message({
              type: "success",
              message: "清空成功!"
            });
            this.load();
            Eve.$emit("businessStatusList");
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },
    edit(obj) {
      this.$refs["ruleForm2_"] &&
        this.$refs["ruleForm2_"].resetFields &&
        this.$refs["ruleForm2_"].resetFields();
      this.dialogFormVisible1 = true;
      for (let i in this.form_) {
        this.form_[i] = obj[i];
      }
     this.form_.capacity=''+this.form_.capacity;
    },
    addList() {
      this.$refs["ruleForm2"].validate(valid => {
        if (valid) {
          this.dialogFormVisible_ = true;
          this.$http.post("/w/tableCard/add", this.form).then(
            () => {
              this.dialogFormVisible_ = false;
              this.dialogFormVisible = false;
              this.load();
              this.$message({
                type: "success",
                message: "添加成功"
              });
            },
            () => {
              this.dialogFormVisible_ = false;
            }
          );
        } else {
          return false;
        }
      });
    },
    donwAll() {
      if (this.multipleSelection.length == 0) {
        this.$notify.error({
          title: "错误",
          message: "请选择至少一个"
        });
      } else {
        let data = [];
        this.multipleSelection.forEach(element => {
          data.push(element.tcForeignId);
        });
        data = data.join(",");
        this.donw(data);
      }
    },
    donw(a) {
      let data = {
        tcCheckedForeignIds: a,
        tokenId: localStorage.getItem("tokenId")
      };
      this.$refs["exportFile"].export(data);
    },
    handleCurrentChange(index) {
      this.page.currentPage = index;
      this.load();
    },
    load() {
      this.fullscreenLoading = true;
      this.formInline.startTime = !this.value7 ? null : this.value7[0];
      this.formInline.endTime = !this.value7 ? null : this.value7[1];
      this.$http
        .post(
          `/w/tableCard/s?page=${this.page.currentPage - 1}&size=${
            this.formInline.size
          }`,
          this.formInline
        )
        .then(data => {
          this.fullscreenLoading = false;
          this.tableData3 = data.data;
          this.page.total = data.pageable.totalElements;
        })
        .catch(error => {
          this.fullscreenLoading = false;
        });
    },
    search() {
      this.page.currentPage = 1;
      this.load();
    },
    editList() {
      this.$refs["ruleForm2_"].validate(valid => {
        if (valid) {
          this.dialogFormVisible1_ = true;
          this.$http.post("/w/tableCard/modify", this.form_).then(
            () => {
              this.dialogFormVisible1_ = false;
              this.dialogFormVisible1 = false;
              this.load();
              this.$message({
                type: "success",
                message: "修改成功"
              });
            },
            () => {
              this.dialogFormVisible1_ = false;
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    open3() {
      this.dialogFormVisible = true;
      this.$refs["ruleForm2"] &&
        this.$refs["ruleForm2"].resetFields &&
        this.$refs["ruleForm2"].resetFields();
    },
    onSubmit() {
      console.log("submit!");
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
</script>

<style scoped>
.right {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/view/page/tableAdmin/tableAdmin.vue